<template>
  <v-card style="width: 100%">
    <v-card-text class="pa-6">
      <div>
        <LineChart style="width: 100%; position: relative" :chartdata="chartData" :options="chartOptions" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import LineChart from '../../../components/basic/chart/LineChart.vue'
import { Diligence } from '@/plugins/api'
export default {
  components: { LineChart },
  props: {
    filters: Object
  },
  data() {
    return {
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                stepSize: 10,
                reverse: false,
                beginAtZero: true
              }
            }
          ]
        }
      },
      loaded: false
    }
  },
  mounted() {},
  methods: {
    async searchStudentDiligences() {
      this.$loading.active = true

      try {
        const data = await Diligence.getAbsentChartData({ ...this.filters })
        this.processData(data)
      } catch (error) {
        this.$alert.error('Không lấy được danh sách chuyên cần')
        console.error(error)
      }
      this.$loading.active = false
    },
    processData(data) {
      const labels = data.map(item => item.date)
      const absentNumbers = data.map(item => item.absentNumber)
      const validNumbers = data.map(item => item.validNumber)
      const invalidNumbers = data.map(item => item.invalidNumber)

      this.chartData = {
        labels: labels,
        datasets: [
          {
            label: 'Vắng mặt',
            backgroundColor: '#FF9800',
            borderColor: '#FF9800',
            data: absentNumbers,
            fill: false,
            lineTension: 0
          },
          {
            label: 'Có phép',
            borderColor: '#c9c9c9',
            backgroundColor: '#c9c9c9',
            data: validNumbers,
            fill: false,
            lineTension: 0
          },
          {
            label: 'Không phép',
            backgroundColor: '#FBC02D',
            borderColor: '#FBC02D',
            data: invalidNumbers,
            fill: false,
            lineTension: 0
          }
        ]
      }
    }
  }
}
</script>

<style scoped></style>
